import { pickQueryParams } from '../../../shared/helpers/url';

const ALLOWED_CONFERENCE_QUERY_PARAMS = ['yt-token'];

// Для yandex-team встреч uri от бэка приходит в виде http://telemost.yandex-team.ru/j/123
// но это невалидный uri для запросов в cloud api. Поэтому нормализуем uri, убирая yandex-team.
// https://st.yandex-team.ru/CHEMODAN-89719
export function normalizeConferenceUri(uri: string) {
    return uri.replace('yandex-team', 'yandex');
}

export function getConferenceQueryString(searchString?: string) {
    const queryParamsString = pickQueryParams(searchString ?? '', ALLOWED_CONFERENCE_QUERY_PARAMS).toString();

    return queryParamsString ? `?${queryParamsString}` : '';
}

export function resolveConferenceUri(uri: string, searchString?: string) {
    return normalizeConferenceUri(`${uri}${getConferenceQueryString(searchString)}`);
}
